<div class="insta-card" [ngClass]="theme">
  <div class="insta-card-header">

    @if (topic) {
      <div class="insta-card-topic">
        <img
          class="topic-image"
          [cropImage]="topic.mediaImage | preSignedUrl | async"
          [crop]="topic?.mediaImage?.crop"
          [additionalOptions]="topic?.mediaImage?.additionalMediaProps"
          [imageWidth]="400">
        <h5 class="insta-card-title" ellipsis [ellipsis-content]="topic.title"></h5>
      </div>
    } @else {
      <h5 class="insta-card-title" ellipsis [ellipsis-content]="item.title"></h5>
    }


    <div class="card-actions" (click)="$event.stopPropagation()">
      @if (videoPlayer?.plyr || (audio && !mediaAutoplay)) {
        <button mat-icon-button
          class="button button--icon button--transparent button--white-text button--icon-extra-small"
          (click)="playMedia($event)">
          <lib-icon [icon]="mediaPlaying ? 'pause' : 'play'"></lib-icon>
        </button>
      }

      @if (audio || videoPlayer?.plyr) {
        <button mat-icon-button
          class="button button--icon button--transparent button--white-text button--icon-extra-small"
          (click)="toggleMute()">
          <lib-icon [icon]="muted ? 'speaker-simple-slash' : 'speaker-simple-high'"></lib-icon>
        </button>
      }

      <ng-content select="[card-header]"></ng-content>

      @if (showLike) {
        <div class="like-wrapper">
          @if (item.totalLikes) {
            {{ item.totalLikes | numberFormat:{notation: 'compact'} }}
          }

          <button
            mat-icon-button
            class="button button--icon button--transparent button--white-text button--icon-extra-small"
            (click)="toggleLike()">
            <lib-icon icon="heart" [fill]="item.userLiked"></lib-icon>
          </button>
        </div>
      }

    </div>
  </div>

  <div
    class="insta-card-media"
    [class.placeholder]="!previewImage && !item?.mediaImage"
    [dynamicWidthCoeff]="3"
    [cardBackground]="{ mediaBackground: previewImage ? previewImage : item?.mediaImage, backgroundColor: null }">

    <div class="media-content-overlay">
      <div class="ck-text text-overlay" [ngClass]="item.textAlignment">
        @if (item.textEnabled && item.text) {
          <ng-scrollbar class="text-scrollbar">
            <div [innerHTML]="item.text | safeHtml"></div>
          </ng-scrollbar>
        }
      </div>

      @if (item.linkToContent || item.link?.uri) {
        <button
          mat-button 
          class="button link-to-content-button" 
          [class.is-dark]="isButtonDark"
          [style.backgroundColor]="item.buttonColor"
          [style.backdropFilter]="item.buttonBlur ? 'blur( ' + item.buttonBlur + ' )' : ''"
          (click)="navigateToContent($event)">
          <lib-icon icon="link" [size]="16"></lib-icon>
            {{ item.buttonLabel }}
        </button>
      }
    </div>

    @if (mediaEnabled && item?.type === mediaTypes.IMAGE && item.mediaAudio) {
      <audio
        #audioElement
        class="card-audio"
        [loop]="mediaAutoplay"
        [autoplay]="mediaAutoplay"
        [src]="item.mediaAudio | preSignedUrl : entityTypeIds.MEDIA : bundles.AUDIO : fieldNames.AWS_FILE | async"
      [muted]="muted"></audio>
    }

    @if (mediaEnabled && item?.type === mediaTypes.VIDEO && item.mediaVideo) {
      <lib-video
        class="background-video background-video--absolute position-cover"
        [src]="item.mediaVideo | videoPresign | async"
        [poster]="previewImage ? { uri: previewImage | preSignedUrl | async } : { uri: item.mediaImage | preSignedUrl | async, crop: item.mediaImage?.crop}"
        [hideControls]="true"
        [loop]="mediaAutoplay"
        [autoplay]="{ enabled: mediaAutoplay || videoPlayer?.plyr?.playing, volume: (audio || muted) ? 0 : 1 }">
      </lib-video>
    }
  </div>
</div>
